<mat-card class="filas-ns-panel">
  <app-card-header
    title="Filas de downlinks en el network server"
    subtitle="Dispositivos con downlinks sin entregar"
    icono="playlist_remove"
    [botonCerrar]="true"
    (cerrar)="cerrar()"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    <div class="fnp-barra">
      <mat-checkbox
        [(ngModel)]="soloOffline"
        (ngModelChange)="cargar()"
        [disabled]="cargando || trabajando"
        matTooltip="El mismo alcance que el barrido automático: los que están fuera de su tiempo límite de comunicación"
      >
        Sólo los sin comunicación
      </mat-checkbox>

      <span class="fnp-spacer"></span>

      @if (cargando || trabajando) {
        <mat-spinner diameter="22"></mat-spinner>
      }
    </div>

    @if (resumen) {
      <div class="chips-dato-grid">
        <app-chip-dato
          label="Dispositivos escaneados"
          [valor]="resumen.escaneados"
          icon="router"
          color="gris"
          hint="Sólo clase B/C: un clase A no puede acumular fila"
        />
        <app-chip-dato
          label="Con downlinks en fila"
          [valor]="resumen.conItems"
          icon="playlist_add"
          [color]="resumen.conItems ? 'naranja' : 'verde'"
          hint="Cada uno hace fallar al scheduler en cada tick"
        />
        <app-chip-dato
          label="Downlinks en total"
          [valor]="resumen.totalItems"
          icon="south"
          color="gris"
          hint="Sumados sobre todos los dispositivos sucios"
        />
        <app-chip-dato
          label="Vencidos"
          [valor]="resumen.totalVencidos"
          icon="timer_off"
          [color]="resumen.totalVencidos ? 'rojo' : 'gris'"
          hint="Pasó su expiresAt: es basura segura de borrar"
        />
        <app-chip-dato
          label="Sin vencimiento"
          [valor]="resumen.totalSinVencimiento"
          icon="do_not_disturb_on"
          [color]="resumen.totalSinVencimiento ? 'rojo' : 'gris'"
          hint="Sin expiresAt: el network server no los descarta nunca por su cuenta"
        />
      </div>

      @if (resumen.errores) {
        <app-info-banner
          icon="error_outline"
          [message]="
            resumen.errores +
            ' dispositivo(s) no se pudieron consultar en Chirpstack.'
          "
          [closable]="false"
          margin="0"
        ></app-info-banner>
      }

      @if (resumen.conItems) {
        <div class="fnp-tabla-wrap">
          <table class="fnp-tabla">
            <thead>
              <tr>
                <th>Dispositivo</th>
                <th>DevEUI</th>
                <th>Tipo</th>
                <th>Comunicación</th>
                <th>En fila</th>
                <th>Vencidos</th>
                <th>Sin venc.</th>
                <th>Estado</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (d of resumen.devices; track d.deveui) {
                <tr>
                  <td>
                    @if (d.name) {
                      {{ d.name }}
                    } @else {
                      <span class="no-info">Sin nombre</span>
                    }
                  </td>
                  <td class="mono">{{ d.deveui }}</td>
                  <td>
                    @if (d.tipo) {
                      {{ d.tipo }}
                    } @else {
                      <span class="no-info">Sin tipo</span>
                    }
                  </td>
                  <td>
                    @if (d.offline) {
                      <span
                        class="badge badge-rojo"
                        [matTooltip]="d.motivoOffline || ''"
                      >
                        Sin comunicación
                      </span>
                    } @else {
                      <span class="badge badge-verde">Con comunicación</span>
                    }
                  </td>
                  <td class="num">{{ d.totalItems }}</td>
                  <td class="num">{{ d.itemsVencidos }}</td>
                  <td class="num">{{ d.itemsSinVencimiento }}</td>
                  <td>
                    @if (d.todosDescartables) {
                      <span
                        class="badge badge-rojo"
                        matTooltip="Ningún downlink suyo vale ya (vencidos o sin vencimiento): vaciarla no pierde nada"
                      >
                        Fila huérfana
                      </span>
                    } @else {
                      <span
                        class="badge badge-amarillo"
                        matTooltip="Tiene downlinks todavía vigentes: el barrido automático no la toca"
                      >
                        Con vigentes
                      </span>
                    }
                  </td>
                  <td class="acciones">
                    <button
                      irxBotonIcono
                      type="button"
                      (click)="verDetalle(d)"
                      tooltip="Ver los downlinks de esta fila"
                    >
                      <mat-icon>visibility</mat-icon>
                    </button>
                    <button
                      irxBotonIcono
                      tono="peligro"
                      type="button"
                      (click)="flushUno(d)"
                      [disabled]="trabajando"
                      tooltip="Vaciar la fila de este dispositivo"
                    >
                      <mat-icon>delete_sweep</mat-icon>
                    </button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      } @else if (!cargando) {
        <div class="fnp-vacio">
          <mat-icon>check_circle</mat-icon>
          Ningún dispositivo tiene downlinks sin entregar en el network server.
        </div>
      }
    }
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <button irxBoton="secundario" type="button" (click)="cerrar()">Cerrar</button>
    <button
      irxBoton="secundario"
      type="button"
      (click)="cargar()"
      [disabled]="cargando || trabajando"
    >
      <mat-icon>refresh</mat-icon>
      Re-escanear
    </button>
    <button
      irxBoton="peligro"
      type="button"
      (click)="flushDescartables()"
      [disabled]="!descartables.length || cargando || trabajando"
      tooltip="Vacía sólo las filas donde ningún downlink vale ya: vencidos o sin vencimiento. No puede perder nada útil"
    >
      <mat-icon>delete_sweep</mat-icon>
      Vaciar sin valor ({{ descartables.length }})
    </button>
  </mat-card-actions>
</mat-card>
